export class CommaSpaceValueConverter {
    fromView(value:string) {
        //
    }
    toView(value:string) {
        return value.replace(",", ", ");
    }
}